import { IEntity } from './entity';
import { IRosterType } from './roster/roster-type';
import { Position } from './position';
import { IWorkArea } from './workarea';
import { IEmployer } from './employer';

export class Employee {
  id: number;
  employeeNo: string;
  accessId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  nickname: string;
  address: string;
  city: string;
  state: any;
  postcode: string;
  email: string;
  phone: string;
  position: Position;
  positionStartDate: Date;
  hireDate: Date;
  dateOfBirth: Date;
  workGroup: IEntity;
  employer: IEmployer;
  supervisor: Employee;
  contractExpireDate: Date;
  workArea: IWorkArea;
  active: boolean;
  terminateDate: Date;
  terminateNote: string;
  rosterType?: IRosterType;
  rosterTypeStartDate?: Date;
  showInRoster?: boolean;
}

